// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".state-item+.state-item[data-v-a442f5dc]{margin-left:16px}.state-item[data-v-a442f5dc]{flex:1;display:flex;align-items:center;background:#f4f6f9;padding:8px 20px;border:1px solid #f4f6f9}.state-item.is-hand[data-v-a442f5dc]{cursor:pointer}.state-item.is-hand[data-v-a442f5dc]:hover,.state-item.is-select[data-v-a442f5dc]{border:1px solid #5088ff}.state-item .name[data-v-a442f5dc]{font-size:1.1428571429rem;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;color:#586474}", ""]);
// Exports
module.exports = exports;
